import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center ml-auto" }
const _hoisted_2 = { class: "ml-1 pipeline-status-label" }
const _hoisted_3 = { class: "ml-1 pipeline-status-label" }
const _hoisted_4 = { class: "ml-1 pipeline-status-label" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_mobility_flagging_monitor_table = _resolveComponent("mobility-flagging-monitor-table")!
  const _component_base_table = _resolveComponent("base-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["ml-auto pipeline-status-indicator", $setup.PipelineStatus.Succeeded])
          }, null, 2),
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('success')), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["ml-3 pipeline-status-indicator", $setup.PipelineStatus.InProgress])
          }, null, 2),
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t('running')), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["ml-3 pipeline-status-indicator", $setup.PipelineStatus.Failed])
          }, null, 2),
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('failed')), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "mt-2 mb-1" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            ($setup.loadingPipelineRuns && !$setup.pipelineRuns.length)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.$t('loading')), 1))
              : (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString($setup.pipelineRuns.length) + " · " + _toDisplayString(_ctx.$t('pipelineRuns')), 1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "d-block" }, {
      default: _withCtx(() => [
        _createVNode(_component_base_table, {
          "show-loading-table": $setup.loadingPipelineRuns && !$setup.pipelineRuns.length,
          "show-no-content-table": !$setup.pipelineRuns.length,
          "error-message": _ctx.$t('noRuns')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_mobility_flagging_monitor_table, {
              "pipeline-runs": $setup.pipelineRuns,
              "sort-params": $setup.sortParams,
              onUpdateSortParams: $setup.updateSortParams
            }, null, 8, ["pipeline-runs", "sort-params", "onUpdateSortParams"])
          ]),
          _: 1
        }, 8, ["show-loading-table", "show-no-content-table", "error-message"])
      ]),
      _: 1
    })
  ], 64))
}